import { render } from "./Performances.vue?vue&type=template&id=6f23009a"
import script from "./Performances.vue?vue&type=script&lang=js"
export * from "./Performances.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__